import { Field, ErrorMessage } from "formik";
import { fieldClass } from "../assets/classes/fieldClasses";
interface IFormikFields {
  name?: string;
  row?: string;
  label?: string;
  extraValidations?: string;
  type?: string;
  autoComplete?: string;
  disabled?: boolean;
  options?: { label: string; value: any }[];
  value?: string;
  onChange?: any;
  className? : string;
  onKeyDown?: any 
  placeholder?:any
}
const FormikInput = (props: IFormikFields) => {
  const {
    name,
    label,
    extraValidations,
    type,
    autoComplete,
    row,
    options,
    disabled,
    onChange,
    value,
    onKeyDown,
    placeholder
  } = props;

  return type === "select" ? (
    <div>
      <label className="block mb-2 text-sm text-gray-800" htmlFor={name}>
        {label}
      </label>
      <Field
        disabled={disabled}
        className={
          "w-full px-4 py-2 text-base border border-gray-300 rounded outline-none focus:ring-blue-500 focus:border-blue-500 focus:ring-1"
        }
        as="select"
        name={name}
      >
        <option value="">{label}</option>
        {options?.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </Field>
      <ErrorMessage
        component="span"
        style={{ color: "red", fontSize: 13 }}
        name={name}
      />
    </div>
  ) : type === "textarea" ? (
    <div className="w-full md:w-full">
      <label className="block mb-2 text-sm text-gray-800" htmlFor={name}>
        {label}
      </label>
      <Field
        disabled={disabled}
        className={fieldClass}
        name={name}
        as="textarea"
        rows={row}
      />
      <ErrorMessage
        component="span"
        style={{ color: "red", fontSize: 13 }}
        name={name}
      />
    </div>
  ) : (
    <div>
      <label className="block mb-2 text-sm text-gray-800" htmlFor={name}>
        {label}
      </label>
      <Field
        disabled={disabled}
        autoComplete={autoComplete}
        type={type}
        className={fieldClass}
        name={name}
        onKeyDown={onKeyDown}
      />
      <ErrorMessage
        component="span"
        style={{ color: "red", fontSize: 13 }}
        name={name}
      />
      {extraValidations && (
        <span style={{ color: "red", fontSize: 13 }}>
          {extraValidations && extraValidations}
        </span>
      )}
    </div>
  );
};
export default FormikInput;
